import { render, staticRenderFns } from "./grid.vue?vue&type=template&id=056b808c&scoped=true&"
import script from "./grid.vue?vue&type=script&lang=ts&"
export * from "./grid.vue?vue&type=script&lang=ts&"
import style0 from "./grid.vue?vue&type=style&index=0&id=056b808c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056b808c",
  null
  
)

export default component.exports